import { createSlice } from '@reduxjs/toolkit';

export enum BASE_URL {
  PROD = `https://api.imprint.co`,
  STG = `https://int.stg.imprintapi.co`,
  SBX = `https://sbx.imprint.co`,
  PREPRD = `https://int.preprd.imprintapi.co`,
  ASSET = 'https://app.stg.imprint.co',
}

export enum ENV {
  LOCAL = 'localhost',
  STG = 'stg',
  SBX = 'sbx',
  PROD = 'prod',
  PREPRD = 'preprd',
}

export interface ApiState {
  baseURL: string;
  env: string;
  apikey: string;
  internalAuthRequired: boolean;
  deviceID: string;
  sessionID: string;
  clientSecret: string;
  partnerCustomerId: string;
  telemetryID: string;
}

const initialState: ApiState = {
  baseURL: '',
  env: '',
  apikey: '',
  internalAuthRequired: false,
  deviceID: '',
  sessionID: '',
  clientSecret: '',
  partnerCustomerId: '',
  telemetryID: '',
};

const apiScreenSlice = createSlice({
  name: 'apiState',
  initialState,
  reducers: {
    setBaseURL: (state, action) => {
      state.baseURL = action.payload;
    },
    setEnv: (state, action) => {
      state.env = action.payload;
    },
    setApiKey: (state, action) => {
      state.apikey = action.payload;
    },
    setInternalAuthRequired: (state, action) => {
      state.internalAuthRequired = action.payload;
    },
    setDeviceID: (state, action) => {
      state.deviceID = action.payload;
    },
    resetDeviceID: (state) => {
      state.deviceID = initialState.deviceID;
    },
    setSessionID: (state, action) => {
      state.sessionID = action.payload;
    },
    resetSessionID: (state) => {
      state.sessionID = initialState.sessionID;
    },
    setClientSecret: (state, action) => {
      state.clientSecret = action.payload;
    },
    setPartnerCustomerId: (state, action) => {
      state.partnerCustomerId = action.payload;
    },
    setTelemetryID: (state, action) => {
      state.telemetryID = action.payload;
    },
  },
});

export const {
  setBaseURL,
  setEnv,
  setApiKey,
  setInternalAuthRequired,
  setDeviceID,
  resetDeviceID,
  setSessionID,
  resetSessionID,
  setClientSecret,
  setPartnerCustomerId,
  setTelemetryID,
} = apiScreenSlice.actions;
export default apiScreenSlice.reducer;
